module.exports = __webpack_public_path__ + "static/media/medal.7aa8017a.svg";